import { lazy } from "react";
import { build } from "../../tools/ConfigBuilder";

export default build([
	{
		path: "/admin/transactions/creation-trip",
		component: lazy(() => import("./TransactionsStateCreationTripPage")),
	},
]);